import AiAgent from '../../../components/units/Management/AiAgent/List';

export default function AiAgentPage() {
  return <AiAgent />;
}
